import React from 'react'
import ReactDOM from 'react-dom/client'
import '@fontsource-variable/archivo'
import '@fontsource-variable/source-serif-4/wght-italic.css'
import App from './App'
import './styles.css'
import './enhancements.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
